import React, { useState, useEffect ,useContext } from 'react';
import * as request from "../admin/lib/lib";
import { ParameterContext } from '../contexts/ParameterContext';

export function Schools() {
    const [schoolsData, setSchoolsData] = useState([]);
    const { parameters } = useContext(ParameterContext);

    const showDirEmail = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name === 'SHOW_DIR_EMAIL_SCHOOLS');

    console.log(showDirEmail.value);

    useEffect(() => {
        const populateSchools = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'GetInfo/Schools');
                //const jsonData = await response.json();

                setSchoolsData(response.schools);
                //setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        populateSchools();
        document.title = `Училища`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.

    const Table = ({ data }) => {

        const rows = [];
        let currentRajon = null;
        let counter = 1;

        schoolsData.forEach((item, i) => {
            if (currentRajon !== item.rajon || counter === 1) {
                // This checks if it's the first row in the group

                if (counter !== 1) {
                    rows.push(
                        <tr key={`group_separator_${item.rajon}_${i}`}>
                            {showDirEmail.value == 1 ? <td colSpan="4">&nbsp;</td>: <td colSpan="3">&nbsp;</td>}
                            
                        </tr>
                    );
                }

                if (item.rajon !== '') {
                    rows.push(
                        <tr key={`group_header_${item.rajon}_${i}`}>
                            
                            {showDirEmail.value == 1 ? <td colSpan="4"><b>{item.rajon}</b></td> : <td colSpan="3"><b>{item.rajon}</b></td>}
                        </tr>
                    );
                }

                rows.push(
                    <tr key={`group_columns_${item.rajon}_${i}`} className="color-bg-cl">
                        <th className="text-left">УЧИЛИЩЕ</th>
                        <th className="text-left">АДРЕС</th>

                        {showDirEmail.value == 1 ?<><th className="text-left">ДИРЕКТОР</th></> : ''}

                        <th className="text-left">УЕБСАЙТ</th>
                    </tr>
                );
                currentRajon = item.rajon;
            }


            rows.push(
                <tr key={item.idSchool}>
                    <td className="p-2">{item.name}</td>
                    <td className="p-2">{item.address}</td>
                    {showDirEmail.value == 1 ? <><td className="p-2">{item.nameDirector}</td></> : ''}
                    <td className="p-2 text-wrap"><a href={item.website} className="text_link" target="_blank" rel="noopener noreferrer">{item.website}</a></td>
                </tr>
            );

            counter++;

        });

        return (
            <table className="table table-bordered  table-responsive-stack mt-5 ">

                <tbody>{rows}</tbody>
            </table>
        );
    };

    return (
        <div>
            <div className="cust_table" >
                <div className="title_news">Училища</div>
                {schoolsData.length === 0 ? (
                    <p>...</p>
                ) : (
                    //schoolsData.map((sd, index) => (
                    <Table data={schoolsData} />
                    //))
                )}
            </div>
        </div>
    );
}

export default Schools;